import { render, staticRenderFns } from "./Aliment.vue?vue&type=template&id=318ba242&scoped=true&"
import script from "./Aliment.vue?vue&type=script&lang=js&"
export * from "./Aliment.vue?vue&type=script&lang=js&"
import style0 from "./Aliment.vue?vue&type=style&index=0&id=318ba242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ba242",
  null
  
)

export default component.exports